/* eslint-disable */


// Programatically generated on Wed Dec 17 2025 18:09:01 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'test_fridges_v1',
    'attributes': {
      'number_of_hot_pockets': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'number_of_bagel_bites': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'number_of_tostinos_pizza_rolls': {
        'type': 'integer',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {}
  }
);

const ModelRecord = Record(
  {
    'number_of_hot_pockets': Empty,
    'number_of_bagel_bites': Empty,
    'number_of_tostinos_pizza_rolls': Empty,
    'updated_at': Empty,
    'inserted_at': Empty,
    'id': Empty,
    'relationshipMeta': Empty,
    'meta': new Map({
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'number_of_hot_pockets': 0,
    'number_of_bagel_bites': 0,
    'number_of_tostinos_pizza_rolls': 0,
    'id': '',
    'updated_at': new Date(),
    'inserted_at': new Date(),
    'meta': new Map(),
    'relationshipMeta': new Map()
  }
);

export class TestFridgeModelV1 extends GenericModel(ModelRecord, ModelConfig, 'TestFridgeModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyTestFridgeModelV1Model = _emptyTestFridgeModelV1Model ? _emptyTestFridgeModelV1Model : new TestFridgeModelV1(DefaultModel);
    return _emptyTestFridgeModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'TestFridgeModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'test_fridge_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {integer}
   */
  getNumberOfBagelBites() {
    const value = this.getValueForAttribute('number_of_bagel_bites');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setNumberOfBagelBites(value) {
    return this.setField('number_of_bagel_bites', value);
  }

  /**
   * @type {integer}
   */
  getNumberOfHotPockets() {
    const value = this.getValueForAttribute('number_of_hot_pockets');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setNumberOfHotPockets(value) {
    return this.setField('number_of_hot_pockets', value);
  }

  /**
   * @type {integer}
   */
  getNumberOfTostinosPizzaRolls() {
    const value = this.getValueForAttribute('number_of_tostinos_pizza_rolls');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setNumberOfTostinosPizzaRolls(value) {
    return this.setField('number_of_tostinos_pizza_rolls', value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
}

// -- Empty Model Instance --
let _emptyTestFridgeModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'id': null,
  'inserted_at': null,
  'number_of_bagel_bites': null,
  'number_of_hot_pockets': null,
  'number_of_tostinos_pizza_rolls': null,
  'updated_at': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.populated_metadata_fields': new Set(['null']),
  'number_of_bagel_bites': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'number_of_hot_pockets': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'number_of_tostinos_pizza_rolls': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
  },
  required: {
  }
});

// -- Legacy Name Export --
export const TestFridge = TestFridgeModelV1;
